
import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator';
import { messages } from '@/@next/i18n';
import { TimelineContentData, TimelineContentEventData } from '@/@types/graphql';
import { CLoader } from '@/components/loader';
import { CImage } from '@/@next/components/image';
import _shuffle from 'lodash/shuffle';

const config = {
  name: 'c-timeline-full-screen-image-slider',
  i18n: { messages },
  components: {
    CLoader,
    CImage,
  }
};

@Component(config)
export default class CTimelineFullScreenImageSlider extends Vue {
  @Prop({ type: Object, required: true }) timeline!: TimelineContentData
  @Prop({ type: Number, required: false, default: 0 }) current!: number
  @Prop({ type: Boolean, required: false, default: false }) shuffle!: boolean

  selectedEvent: any | null = null;
  eventPlaced: Array<any | null> = [];

  @Watch('current')
  onCurrentIndexChanged () {
    const container = document.getElementById('scrollable-events');
    if (!container) return
    const item = document.getElementById(`full-screen-event-${this.current}`);
    if (!item) return
    const containerWidth = container.offsetWidth;
    const itemWidth = item.offsetWidth;
    const itemOffsetLeft = item.offsetLeft;
    const scrollLeft = itemOffsetLeft - (containerWidth - itemWidth) / 2;
    container.scrollLeft = scrollLeft;
  }

  get events () {
    return _shuffle(this.timeline?.events || [])
  }

  get event () {
    return this.events[this.current];
  }

  get hasInstruction () {
    return this.timeline.options.isGame
          && this.timeline.i18n.instruction
          && this.timeline.i18n.instruction.value.text.length > 1
  }

  get instruction () {
    return 'Choisi la bonne image' // this.timeline.i18n.instruction?.value.html
  }

  selectEvent (event: any | null) {
    if (!event) return (this.selectedEvent = null);
    if (this.selectedEvent?.id === event.id) this.selectedEvent = null;
    else this.selectedEvent = event;
    this.$emit('select', event.id);
  }

  startDrag (evt: any, itemId: any) {
    // console.log('startDrag', evt, itemId);
    // element.style.left = evt.gesture.touches[0].pageX;
    // element.style.top = evt.gesture.touches[0].pageY;
    if (!evt || !evt.dataTransfer || !itemId) return;
    const item = this.events.find(({ id }: any) => id === itemId);
    if (!item) return;
    this.selectEvent(item);
    // if (!evt?.dataTransfer) evt.dataTransfer = {}
    evt.dataTransfer.dropEffect = 'move';
    evt.dataTransfer.effectAllowed = 'move';
    evt.dataTransfer?.setData('itemId', itemId);
  }

  stopDrag = () => {
    this.selectEvent(null);
  }

  isPlaced (event: any) {
    if (!event) return null;
    return this.eventPlaced.find((e: any) => e?.id === event.id) || null;
  }

  isCorrect (event: any) {
    if (!event) return null;
    return this.isPlaced(event)?.correct || false;
  }

}
